import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthTokenService } from '@core/authentication/auth-token.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private authTokenService: AuthTokenService,
    ) { }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({
            setHeaders: {
                Authorization: `Bearer ${ this.authTokenService.encodedToken }`,
            },
        });

        return next.handle(request);
    }
}
